import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/useLocale";
import "./EnterpriseBand.css";

/**
 * Entrada a /empresas desde la home.
 *
 * La home le habla a todos -pymes que quieren un empleado virtual y empresas
 * que buscan un proveedor de software-, y quien compra para una empresa no
 * tenia un camino propio. Es una banda corta y neutra, sin color de producto,
 * puesta despues de los tres servicios: ya vio que hacemos y ahora le decimos
 * donde esta lo que revisa un area de tecnologia o de compras.
 */
function EnterpriseBand() {
  const { t, path } = useLocale();
  const band = t.enterprise.homeBand;

  return (
    <section className="enterprise-band" aria-labelledby="enterprise-band-title">
      <div className="enterprise-band__inner">
        <div className="enterprise-band__copy">
          <p className="enterprise-band__eyebrow">{band.eyebrow}</p>
          <h2 className="enterprise-band__title" id="enterprise-band-title">
            {band.title}
          </h2>
          <p className="enterprise-band__text">{band.text}</p>
        </div>

        <Link to={path("enterprise")} className="enterprise-band__cta">
          {band.cta} →
        </Link>
      </div>
    </section>
  );
}

export default EnterpriseBand;
